// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FilterSwitch_wrap__UpTkP"};